import * as CardCrawl from "@ravalmatic/cardcrawl-engine";
import { Button } from "../../../utils/Button";
import { GameVars } from "../../../GameVars";
import { AudioManager } from "../../../AudioManager";
import { BoardContainer } from "../BoardContainer";
import { EventType } from "../../../Types";

export class MulliganButton extends Phaser.GameObjects.Container {

    public enabled: boolean;

    private deltaLifeLabel: Phaser.GameObjects.Text;
    private btn: Button;   
    private handCursor: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.btn = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_mulligan_off", "btn_mulligan_off");
        this.btn.setInflationTween(1.07);
        this.btn.onDown(this.onClearBtn, this);
        this.add(this.btn);

        this.deltaLifeLabel = new Phaser.GameObjects.Text(scene, -2, -11, "-5", { fontFamily: "AlmendraBold", fontSize: "46px", color: "#663227" });
        this.deltaLifeLabel.setOrigin(.5);
        this.add(this.deltaLifeLabel);
    }

    public update(): void {

        if (GameVars.cardCrawlEngine === null) {
            return;
        }

        const state = GameVars.cardCrawlEngine.getState();

        const upperTableau = state.upperTableau;

        if (Boolean(upperTableau[0] && upperTableau[1] && upperTableau[2] && upperTableau[3]) && !BoardContainer.currentInstance.cardSelectionBlocked) {
            this.enable();
        } else {
            this.disable();
        }

        this.deltaLifeLabel.setText("-" + (5 + state.clearCounter * 2).toString());
    }

    public showHandCursor(): void {

        this.handCursor = new Phaser.GameObjects.Image(this.scene, -20, -5, "texture_atlas_1", "hand_cursor");
        this.handCursor.setOrigin(0);
        this.handCursor = this.handCursor.setScale(-1, 1);
        this.add(this.handCursor);

        this.scene.tweens.add({
            targets: this.handCursor,
            x: -10,
            scaleX: -.9,
            scaleY: .9,
            yoyo: false,
            repeat: -1,
            duration: 900,
            loopDelay: 900,
        });

        this.parentContainer.bringToTop(this);
    }

    public startGame(): void {

        const state = GameVars.cardCrawlEngine.getState();
        const upperTableau = state.upperTableau;

        this.enabled = Boolean (upperTableau[0] && upperTableau[1] && upperTableau[2] && upperTableau[3]); 

        if (!this.enabled) {
            this.btn.disableInteractive();
            this.btn.alpha = .5;
            this.deltaLifeLabel.alpha = .5;
        }
    }

    public disable(): void {

        if (!this.enabled) {
            return;
        }

        this.enabled = false;

        this.btn.disableInteractive();
        this.btn.alpha = .5;
        this.deltaLifeLabel.alpha = .5;
    }

    public enable(): void {

        if (this.enabled) {
            return;
        }

        this.enabled = true;

        this.btn.setInteractive({useHandCursor: true});
        this.btn.alpha = 1;
        this.deltaLifeLabel.alpha = 1;
    }

    private onClearBtn(): void {

        if (this.handCursor) {
            this.handCursor.destroy();
        }

        GameVars.eventsDispatcher.dispatchEvent(new CardCrawl.Event(EventType.MULLIGAN, null));

        AudioManager.playSound("btn_click");
    }
}
